var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseSelect',{attrs:{"options":_vm.options,"label":_vm.$t('lang.speed.msg'),"value":_vm.value},on:{"input":function($event){_vm.$emit('input', parseInt($event.target.value, 10))}}})
}
var staticRenderFns = []

export { render, staticRenderFns }